
import { defineComponent, PropType } from "vue";
import FollowBtn from "~/components/Articles/FollowBtn.vue";
import UserAccountModel from "~/models/UserAccountModel";

export default defineComponent({
  name: "CompanyName",
  components: {
    FollowBtn
  },
  props: {
    userAccount: {
      type: Object as PropType<UserAccountModel>,
      required: true
    }
  }
});
